import { en } from '../config/strings.en';
import { es } from '../config/strings.es';

//TODO: proper detection/handle of system language
const systemLanguage = () => {
  const language = 'en';
  switch (language) {
    case 'es':
      return es;
    default:
      return en;
  }
}

export function currentLanguage() {
  return systemLanguage();
}
